<template>
  <section class="wrap_pop">
    <div class="popbox_wrap">
      <div class="popbox_cont">
        <div class="popbox_cont_head">
          <strong class="pop_tit">출력물 확인</strong>
        </div>
        <!-- 출력물 영역 -->
        <div id="pdf" class="popbox_container"></div>
        <!-- // 출력물 영역 -->
        <button class="pop_full_close" @click="$emit('close')">
          <span>닫기</span>
        </button>
        <div class="popbox_btn">
          <div>
            <button type="button" class="btn color1" @click="confirm">
              확인완료
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { reactive, inject, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
export default {
  name: "ClusCnfScrn",
  components: {},
  setup(props, context) {
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));

    onMounted(async () => {
      await load();
      util.saveLog("009", "출력물확인"); // 009 : 화면진입
      registPrctrCtnsCnfHis();
      retrieveMblClus();
    });

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
    });

    function retrieveMblClus() {
      var paramt = {
        prctrNo: sessionUserInfo.prctrNo,
        bizSysCd: "CTL",
      };
      axios.json("/mobGuid/retrieveMblClus.do", paramt).then(function (result) {
        if (!_.isEmpty(result) && !_.isEmpty(result.data.body.pdfFilePth)) {
          var idx = result.data.body.pdfFilePth.lastIndexOf("/");
          var path = result.data.body.pdfFilePth.substring(0, idx + 1);
          var name = result.data.body.pdfFilePth.substring(idx + 1);

          var options = {
            pdfOpenParams: {
              navpanes: 0,
              toolbar: 0,
              statusbar: 0,
              view: "FitH",
              pagemode: "none",
              page: 0,
            },
            forcePDFJS: true,
            PDFJS_URL:
              "/resources/pdfjs-2.7.570-es5-dist/web/viewer.meritz.html?sndCtnsKdCd=116871&polNo=&prctrNo=" +
              sessionUserInfo.prctrNo,
          };

          var url = "/download.do?addFilePath=" + path + "&addFileNm=" + name;
          var myPDF = PDFObject.embed(url, "#pdf", options);

          // setTimeout(function(){
          // 	var screenH = $(window).height() - 110;
          // 	var $viewer = $('.pdfobject-container');
          // 	$viewer.css('height', screenH);
          // 	$(window).on('resize', function(){
          // 		screenH = $(window).height();
          // 		$viewer.css('height', screenH);
          // 	});
          // }, 500)
        } else if (!_.isEmpty(result.data.body.hmpgFilePth)) {
          var fileName = sessionUserInfo.prctrNo;

          var urlParam = {
            clusUrl: result.data.body.hmpgFilePth,
            fileName: currDate + "_" + fileName,
          };

          axios
            .json("/mobGuid/getURLToFile.do", urlParam)
            .then(function (result) {
              var pdfPath = result.data.pdfPath;
              var fileName = result.data.pdfName;

              var options = {
                pdfOpenParams: {
                  navpanes: 0,
                  toolbar: 0,
                  statusbar: 0,
                  view: "FitH",
                  pagemode: "none",
                  page: 0,
                },
                forcePDFJS: true,
                PDFJS_URL:
                  "/resources/pdfjs-2.7.570-es5-dist/web/viewer.meritz.html?sndCtnsKdCd=116871&polNo=&prctrNo=" +
                  sessionUserInfo.prctrNo,
              };

              var url =
                "/download.do?addFilePath=" +
                pdfPath +
                "&addFileNm=" +
                fileName;
              var myPDF = PDFObject.embed(url, "#pdf", options);

              // setTimeout(function(){
              // 	var screenH = $(window).height() - 110;
              // 	var $viewer = $('.pdfobject-container');
              // 	$viewer.css('height', screenH);
              // 	$(window).on('resize', function(){
              // 		screenH = $(window).height();
              // 		$viewer.css('height', screenH);
              // 	});
              // }, 500)
            });
        } else {
          dialog.alert("오류가 발생하였습니다. (PDF 정보를 찾을 수 없음)");
        }
      });
    }

    function registPrctrCtnsCnfHis() {
      var logParam = {
        bizSysCd: "CTL",
        prctrNo: sessionUserInfo.prctrNo,
        polNo: "",
        mngTrgCtnsKdCd: "119614",
        dataDivCd: "00014",
        sndCtnsKdCd: "116871",
        enrlChnCd: "40",
        ctnsCnfDivCd: "01",
        orgCd: "S00000028",
      };
      axios
        .json("/registPrctrCtnsCnfHis.do", logParam)
        .then(function (result) {});
    }

    const confirm = () => {};

    return {
      state,
      load,
      confirm,
      sessionUserInfo,
    };
  },
};
</script>
